<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router';
import { getRuntimeConfig, isNonProduction } from '@/config';

const config = getRuntimeConfig();
</script>

<template>
  <div class="flex min-h-screen flex-col">
    <!-- Skip link: the first thing in the tab order, invisible until focused. -->
    <a
      href="#main"
      class="visually-hidden focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:h-auto focus:w-auto focus:rounded-xl focus:bg-brand-600 focus:px-4 focus:py-3 focus:text-white"
      style="clip: auto"
    >
      Skip to the form
    </a>

    <!--
      Nobody should mistake test for the real thing, least of all the team.

      Deliberately not role="status": this is a permanent label read in normal document
      order, not something that changes. Announcing it as a live status on every page
      would just be noise.
    -->
    <p
      v-if="isNonProduction()"
      class="no-print bg-ink-800 px-4 py-1.5 text-center text-sm text-ink-100"
    >
      This is the <strong>{{ config.environment }}</strong> version of the site, for testing.
    </p>

    <header class="no-print border-b-2 border-ink-200 bg-white">
      <div class="mx-auto flex max-w-prose items-center justify-between px-4 py-4">
        <RouterLink
          to="/"
          class="font-serif text-lg text-ink-900 hover:text-brand-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600 md:text-xl"
        >
          Railway Street Cookbook
        </RouterLink>
      </div>
    </header>

    <main id="main" class="flex-1">
      <RouterView />
    </main>

    <footer class="no-print border-t-2 border-ink-200 bg-white">
      <div class="mx-auto max-w-prose px-4 py-6 text-sm text-ink-600">
        <p>
          A fundraising cookbook by
          <a
            href="https://railwaystreet.org"
            class="underline underline-offset-2 hover:text-ink-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
            target="_blank"
            rel="noopener noreferrer"
            >Railway Street Presbyterian Church</a
          >.
          <RouterLink
            to="/privacy"
            class="underline underline-offset-2 hover:text-ink-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
          >
            How we use your details
          </RouterLink>
        </p>
        <p class="mt-2 text-ink-400">Version {{ config.version }}</p>
      </div>
    </footer>
  </div>
</template>
